import { useState } from "react";
import {
  browserSessionPersistence,
  setPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../../firebase/firebase";
import "./LoginScreen.css"; // Asegúrate de tener este CSS

export const Login = () => {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const login = async () => {
    try {
      await setPersistence(auth, browserSessionPersistence);
      await signInWithEmailAndPassword(auth, email, pass);
      localStorage.setItem("loginTime", Date.now().toString());
      const redirectTo = location.state?.from || "/admin/panel";
      navigate(redirectTo);
    } catch (e: any) {
      console.error(e);
      setError("Acceso denegado");
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    login();
  };

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleSubmit}>
        <h2>Login Admin</h2>
        <input
          className="login-input"
          placeholder="Correo"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="login-input"
          placeholder="Contraseña"
          type="password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
        />
        <button type="submit" className="login-button">
          Entrar
        </button>
        {error && <p className="login-error">{error}</p>}
      </form>
    </div>
  );
};
